import { Field_Keys, PropKeys } from '../../constants';
import { API } from '../../lib/api';

export const login = async ({ email, password, is_sso }) => {
  const body = {
    email,
    password,
    is_sso,
  };

  const { data, status, error } = await API.POST('login', body);

  if (error || status !== 200) return { status, error };
  const {
    [Field_Keys.USER.PHONE]: phone,
    [Field_Keys.USER.AUTH_TYPE]: auth_type,
  } = data;

  return {
    status,
    [PropKeys.email]: email,
    [PropKeys.phone]: phone,
    [PropKeys.authType]: auth_type,
  };
};
